import React from "react";
import FAQBox from "../FAQBox";
// import BadgeSection from "../BadgeSection";

const RightSidebar = () => {
  return (
    <aside className="space-y-6">
      <FAQBox />
      {/* <BadgeSection/> */}
    </aside>
  );
};

export default RightSidebar;
